<template>
  <TableBasic :payload="payload" @onChange="changeParameter" @onExport="exportWithdraw">
    <template v-slot:admin_fee="{value}">
      <div class="text-decoration-none fw-bold" style="color:#FF434F;">
        {{ filters.rupiah(value) }}
      </div>
    </template>
    <template v-slot:seller_phone="{value}">
      <a
        :href="'https://wa.me/'+value"
        target="_blank"
        rel="noopener"
      >
        {{value}}
      </a>
    </template>
    <template v-slot:withdraw_id="{data}">
      <div>
        <router-link
          :to="`/finance/withdraw/${data.withdraw_id}`"
          class="text-decoration-none fw-bold"
        >
          {{ data.withdraw_id }}
        </router-link>
      </div>
    </template>
  </TableBasic>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";

export default {
  components: {
    TableBasic,
  },
  data() {
    return {
      filterValue: {},
      payload: {
        header: [
          {
            key: "amount_request",
            label: "AMOUNT REQUESTED",
            class: "text-start",
            isCurrency: true
          },
          {
            key: "admin_fee",
            label: "ADMIN FEE",
            class: "text-start",
            isCurrency: true
          },
          {
            key: "amount_withdraw",
            label: "AMOUNT WITHDRAWN",
            class: "text-start",
            isCurrency: true
          },
          {
            key: "bank_code",
            label: "BANK CODE",
            class: "text-start",
          },
          {
            key: "bank_name",
            label: "BANK NAME",
            class: "text-start",
          },
          {
            key: "bank_account_name",
            label: "BANK ACCOUNT NAME",
            class: "text-start",
          },
          {
            key: "bank_account_number",
            label: "BANK ACCOUNT NUMBER",
            class: "text-start",
          },
          {
            key: "description",
            label: "DESCRIPTION",
            class: "text-start",
          },
          {
            key: "seller_phone",
            label: "SELLER PHONE",
            class: "text-start",
          },
          {
            key: "seller_email",
            label: "SELLER EMAIL",
            class: "text-start",
          },
          {
            key: "withdraw_id",
            label: "WITHDRAW ID",
            class: "text-start",
          },
          {
            key: "seller_name",
            label: "SELLER NAME",
            class: "text-start",
          },
          {
            key: "created_date",
            label: "REQUESTED DATE",
            class: "text-start",
            sort: true,
            sort_key : "created_date"
          },
          {
            key: "updated_date",
            label: "REJECTED DATE",
            class: "text-start",
            sort: true,
            sort_key : "updated_date"
          },
          {
            key: "reason",
            label: "REJECTED REASON",
            class: "text-start",
          },
        ],
        value: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: true,
        filterList: [
          {
            label : 'Filter by Requested Date',
            value: "created_date"
          },
          {
            label : 'Filter by Rejected Date',
            value: "updated_date"
          },
        ],
        search: true,
        searchPlaceholder: "Search by Bank Account Name/Bank Account Number/Seller Name",
        sortType : -1,
        sortBy : "" ,
        datepickerOption: {
          autoApply: true,
          timePicker: false,
        },
        // checkbox: true,
        // checkboxKeyId: "withdraw_id",
        export: true,
        exportOptions:{
          disabled: true,
          hidden: true
        }
      },
      dataApprove: {
        formLabel: "Select Withdraw Date",
        titleModal: "WITHDRAW APPROVE",
        textButton: "WITHDRAW",
        actionPath: "withdraw/approve",
        body: {
          seller_withdraw_id: '',
          approve_time: '',
        }
      },
      dataReject: {
        formLabel: "Enter rejection reason",
        titleModal: "REJECT WITHDRAW",
        textButton: "REJECT",
        actionPath: "withdraw/reject",
        body: {
          seller_withdraw_id: '',
          reason: '',
        }
      },
      status: 'REJECT',
    };
  },
  methods: {
    async getData() {
      const payload = {
        page: this.payload.currentPage,
        size: this.payload.perPage,
        status: this.status,
        keyword: this.payload.keyword,
        filterDateBy: 'created_date'
      }

      if(this.filterValue.from) payload.dateStart = this.filterValue.from
      if(this.filterValue.to) payload.dateEnd = this.filterValue.to
      if(this.filterValue.value) payload.filterDateBy= this.filterValue.value

      payload.sort_by = this.payload.sortBy
      payload.sort_type = this.payload.sortType

      const response = await this.$store.dispatch("withdraw/all", payload)
      this.payload.value = response.items
      this.payload.totalRows = response.count
      this.countItems = response.count
    },
    changeParameter(value) {
      this.payload.perPage = value.per_page
      this.payload.currentPage = value.current_page
      this.filterValue = { ...this.filterValue,...value.filter }
      this.payload.keyword = value.search
      this.payload.sortType = value.sort_type
      this.payload.sortBy = value.sort_by
      this.getData()
    },
    async exportWithdraw() {
      const payload = {
        page: this.payload.currentPage,
        size: this.payload.perPage,
        status: this.status,
        keyword: this.payload.keyword,
        filterDateBy: 'created_date'
      }

      if(this.filterValue.from) payload.dateStart = this.filterValue.from
      if(this.filterValue.to) payload.dateEnd = this.filterValue.to
      if(this.filterValue.value) payload.filterDateBy= this.filterValue.value

      payload.sort_by = this.payload.sortBy
      payload.sort_type = this.payload.sortType

      if (this.filterValue) {
        payload.dateStart = this.filterValue.from
        payload.dateEnd = this.filterValue.to
      }

      try{
        const response = await this.$store.dispatch("withdraw/export", payload)
        window.open(response.file_url, '_blank');
      }catch(err){
        console.log({err})
        this.$swal({
          icon: "error",
          title: 'Something Went Wrong',
          text: "Failed Send Request",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },
  mounted() {
    this.getData()
  },
    watch:{
    filterValue (newValue){
      if(newValue?.from && newValue?.to){
        this.payload.exportOptions = {...this.payload.exportOptions, disabled : false, hidden: false}
      }else if(newValue?.from || newValue?.to){
        this.payload.exportOptions = {...this.payload.exportOptions, disabled : true, hidden: false}
      }else{
        this.payload.exportOptions = {...this.payload.exportOptions, disabled : true, hidden: true}
      }
    }
  }
};
</script>

<style></style>
